export default (value: any) => Array.isArray(value)
